/** @typedef {'competition' | 'match'} PermissionScopeType */

/**
 * @typedef {Object} PermissionGrant
 * @property {string} grantId
 * @property {string} principalId Auth uid
 * @property {PermissionScopeType} scopeType
 * @property {string} scopeId
 * @property {string[]} permissions
 */

export const CMOE_CAPABILITIES = {
  COMPETITION_ADMIN: "competition.admin",
  MATCH_CREATE: "match.create",
  MATCH_MANAGE: "match.manage",
  MATCH_START: "match.start",
  MATCH_COMPLETE: "match.complete",
  MATCH_PAUSE: "match.pause",
  MATCH_RESUME: "match.resume",
  MATCH_MANAGER_TRANSFER: "match.manager.transfer",
  MATCH_MANAGER_RECLAIM: "match.manager.reclaim",
  ALLOCATE_PARTICIPANT: "allocate.participant",
  ALLOCATE_RESOURCE: "allocate.resource",
  MATCH_ACTIVITY_UPDATE: "match.activity.update",
  MATCH_VIEW: "match.view",
  ACTIVITY_VIEW: "activity.view",
};

/**
 * @param {string[]} granted
 * @param {string} capability
 */
export function hasCapability(granted, capability) {
  return Array.isArray(granted) && granted.includes(capability);
}

/**
 * Room owner capability set (maps V1 owner).
 * @returns {string[]}
 */
export function roomOwnerCapabilities() {
  return [
    CMOE_CAPABILITIES.COMPETITION_ADMIN,
    CMOE_CAPABILITIES.MATCH_CREATE,
    CMOE_CAPABILITIES.MATCH_MANAGE,
    CMOE_CAPABILITIES.MATCH_START,
    CMOE_CAPABILITIES.MATCH_COMPLETE,
    CMOE_CAPABILITIES.MATCH_PAUSE,
    CMOE_CAPABILITIES.MATCH_RESUME,
    CMOE_CAPABILITIES.MATCH_MANAGER_TRANSFER,
    CMOE_CAPABILITIES.ALLOCATE_PARTICIPANT,
    CMOE_CAPABILITIES.ALLOCATE_RESOURCE,
    CMOE_CAPABILITIES.MATCH_ACTIVITY_UPDATE,
    CMOE_CAPABILITIES.MATCH_VIEW,
    CMOE_CAPABILITIES.ACTIVITY_VIEW,
  ];
}

/**
 * Deputy: same as owner except competition.admin and roster-level admin.
 * @returns {string[]}
 */
export function roomDeputyCapabilities() {
  return roomOwnerCapabilities().filter((c) => c !== CMOE_CAPABILITIES.COMPETITION_ADMIN);
}
